import { Box, Button, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import React from "react";
import { ReactComponent as AlertOctagonIcon } from '../../assets/alert-octagon.svg';
import { ReactComponent as ChatIcon } from '../../assets/chat.svg';
import CloseIcon from '@mui/icons-material/Close';
import './tax-id-theft.css';

export interface ItemModalProps {
    onAction: (action:string) => void,
    partnerName: string,
    phoneNumber: string,
    open: boolean;
  }
  
  export function TaxReturnNotFilingReferralModal({ onAction, partnerName, phoneNumber, open = false }: ItemModalProps): React.JSX.Element {
      
    return (
        <Dialog open={open} sx={{justifyContent: 'center'}} maxWidth={'xs'}>
          <IconButton
          aria-label="close"
          onClick={() => onAction('close')}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            bottom: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
            <DialogContent sx={{mt: 3}}>
                <Box sx={{display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
                    <AlertOctagonIcon height={30} width={30}/>
                    <Typography variant="h5" sx={{textAlign: 'center', mt: 2}}>
                    {'Thank you for confirming that you did not file.'}
                    </Typography>
                    <Typography sx={{textAlign: 'center', mt: 2}}>
                    {`Please contact ${partnerName} at ${phoneNumber} as soon as possible to discuss next steps.`}
                    </Typography>
                </Box>
            </DialogContent>
        </Dialog>
      )
    
  }